<template>
  <div class="threepage">
    <!-- 背景图 -->
    <img class="bg" v-if="isPortrait" src="/assets/~/media/images/activity/film2505-prod/mob/7.jpg" alt="">
    <img class="bg" v-if="!isPortrait" src="/assets/~/media/images/activity/film2505-prod/pc/video-swiper-bg.jpg" alt="">
    <img class="video-swiper-icon" v-if="!isPortrait" src="/assets/~/media/images/activity/film2505-prod/pc/video-swiper-icon.png" alt="">
    <!-- 视频轮播 -->
    <div ref="slideCarousel" class="carousel-container-video" style="overflow: hidden;">
      <div class="swiper-wrapper" id="specialPosition">
        <div class="swiper-slide" 
          v-for="(item, index) in getPartVideos()" :key="item.index">
          <div class="video-container">
            <!-- <div class="icons" v-show="!item.showFullVideo" @click="playFullVideo(index)">
              <a><i class="icon" code-stm="event, PAGEURL, 播放视频按钮"></i></a>
            </div> -->
            <img v-show=" isPortrait "  :src="preText + item.coverUrlMob" @click="playFullVideo(index)" code-stm="event, PAGEURL, 播放轮播视频">
            <img v-show=" !isPortrait "  :src="preText + item.coverUrlPc" @click="playFullVideo(index)" code-stm="event, PAGEURL, 播放轮播视频">
            <!-- 完整视频 -->
            <video width="100%" v-show="item.showFullVideo" :id="getRefName(index)" class="full-video"
              :class="isPortrait ? 'full-video-mob' : 'full-video-pc'" :muted="false" controls 
              :src="item.showFullVideo ? item.url : ''" playsinline></video>
          </div>
          <!-- <div class="video-text">{{ item.text }}</div> -->
        </div>
      </div>
      <div class="swiper-pagination-video"></div>
    </div>
  </div>
</template>
<script>
import { isPortraitFun, isPc, isWeiXin, isAndroid } from "@/utils/utils.js";
import Swiper from "swiper";

export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      preText: 'https://www.kia.cn',
      
      videoUrls: [
        {
          index: 0,
          url: 'https://img.kia.cn/media/videos/202506/dadianying-6.7-1宣传预告片.mp4',
          coverUrlPc: '/assets/~/media/images/activity/film2505-prod/pc/videoswiper-1.png',
          coverUrlMob: '/assets/~/media/images/activity/film2505-prod/mob/videoswiper-1.png',
          showFullVideo: false,
          text: '',
        },
        {
          index: 1,
          url: 'https://img.kia.cn/media/videos/202506/dandianying-6.7-2导演旁白花絮.mp4',
          coverUrlPc: '/assets/~/media/images/activity/film2505-prod/pc/videoswiper-2.png',
          coverUrlMob: '/assets/~/media/images/activity/film2505-prod/mob/videoswiper-2.png',
          showFullVideo: false,
          text: '',
        },
        {
          index: 2,
          url: 'https://img.kia.cn/media/videos/202506/dadianying-6.8拍摄车辆花絮.mp4',
          coverUrlPc: '/assets/~/media/images/activity/film2505-prod/pc/videoswiper-3.png',
          coverUrlMob: '/assets/~/media/images/activity/film2505-prod/mob/videoswiper-3.png',
          showFullVideo: false,
          text: '',
        },
        {
          index: 3,
          url: 'https://img.kia.cn/media/videos/202506/dadianying-6.9EV5路跑花絮.mp4',
          coverUrlPc: '/assets/~/media/images/activity/film2505-prod/pc/videoswiper-4.png',
          coverUrlMob: '/assets/~/media/images/activity/film2505-prod/mob/videoswiper-4.png',
          showFullVideo: false,
          text: '',
        },
        {
          index: 4,
          url: 'https://img.kia.cn/media/videos/202506/dadianying-6.10品牌旁白花絮.mp4',
          coverUrlPc: '/assets/~/media/images/activity/film2505-prod/pc/videoswiper-5.png',
          coverUrlMob: '/assets/~/media/images/activity/film2505-prod/mob/videoswiper-5.png',
          showFullVideo: false,
          text: '',
        },
        {
          index: 5,
          url: 'https://img.kia.cn/media/videos/202506/dadianying-6.11精彩台词上.mp4',
          coverUrlPc: '/assets/~/media/images/activity/film2505-prod/pc/videoswiper-6.png',
          coverUrlMob: '/assets/~/media/images/activity/film2505-prod/mob/videoswiper-6.png',
          showFullVideo: false,
          text: '',
        },
        {
          index: 6,
          url: 'https://img.kia.cn/media/videos/202506/dadianying-6.12精彩台词下.mp4',
          coverUrlPc: '/assets/~/media/images/activity/film2505-prod/pc/videoswiper-7.png',
          coverUrlMob: '/assets/~/media/images/activity/film2505-prod/mob/videoswiper-7.png',
          showFullVideo: false,
          text: '',
        },
        
      ],
      currentPage: 1,
      isShowCover: false,
      swiperCover: null,
      videoCount: 2,
    }
  },
  computed: {
    isSafari() {
      var userAgent = navigator.userAgent;
      if (userAgent.indexOf("Safari") > -1) {
        return true
      } else {
        return false
      } //判断是否Safari浏览器
    }
  },
  watch: {

  },
  mounted() {
    // 添加定时器实时检查日期
    // this.dateCheckInterval = setInterval(() => {
    //   this.checkVideoCountByDate();
    // }, 60000); // 每分钟检查一次
    
    //根据日期判断有几个视频
    // this.checkVideoCountByDate();
    if(window.location.href.includes("date=")){
      if(window.location.href.includes("date=7")){
        this.videoCount = 2
      }else if(window.location.href.includes("date=8")){
        this.videoCount = 3
      }else if(window.location.href.includes("date=9")){
        this.videoCount = 4
      }else if(window.location.href.includes("date=10")){
        this.videoCount = 5
      }else if(window.location.href.includes("date=11")){
        this.videoCount = 6
      }else if(window.location.href.includes("date=12")){
        this.videoCount = 7
      }
    }else{
      //根据当前日期判断有几个视频
      //2025-06.08之前
      if(new Date().getTime() < new Date("2025-06-08").getTime()){
        this.videoCount = 2
      }
      //2025-06.09之前
      else if(new Date().getTime() < new Date("2025-06-09").getTime()){
        this.videoCount = 3
      }
      //2025-06.10之前
      else if(new Date().getTime() < new Date("2025-06-10").getTime()){
        this.videoCount = 4
      }
      //2025-06.11之前
      else if(new Date().getTime() < new Date("2025-06-11").getTime()){
        this.videoCount = 5
      }
      //2025-06.12之前
      else if(new Date().getTime() < new Date("2025-06-12").getTime()){
        this.videoCount = 6
      }
      //2025-06.12及2025-06.12之后
      else if(new Date().getTime() >= new Date("2025-06-12").getTime()){
        this.videoCount = 7
      }
    }
    if (!window.location.href.includes("https://www.kia.cn")) {
      this.preText = 'https://uat.kia.cn'
    } else {
      this.preText = 'https://www.kia.cn'
    }
    // this.slideBanner()
    window.addEventListener("resize", this.setResize);
    var video1 
    var video2 
    var video3 
    var video4 
    var video5 
    var video6 
    var video7 
    var that = this
    this.$nextTick(() => {
      video1 = document.getElementById("videoPlayerSwiper0")
      video2 = document.getElementById("videoPlayerSwiper1")
      video3 = document.getElementById("videoPlayerSwiper2")
      video4 = document.getElementById("videoPlayerSwiper3")
      video5 = document.getElementById("videoPlayerSwiper4")
      video6 = document.getElementById("videoPlayerSwiper5")
      video7 = document.getElementById("videoPlayerSwiper6")
      video1 && video1.addEventListener('ended', this.restartPreviewVideo);
      video2 && video2.addEventListener('ended', this.restartPreviewVideo);
      video3 && video3.addEventListener('ended', this.restartPreviewVideo);
      video4 && video4.addEventListener('ended', this.restartPreviewVideo);
      video5 && video5.addEventListener('ended', this.restartPreviewVideo);
      video6 && video6.addEventListener('ended', this.restartPreviewVideo);
      video7 && video7.addEventListener('ended', this.restartPreviewVideo);
      
      //图片轮播
      if (this.isPortrait) {
        var slidesperviewImg = 1
        var slidesperviewVideo = 1.2
        var initialslide = 0
        var spacebetween1 = 0
        var spacebetween2 = 0
      } else {
        var slidesperviewImg = 2.5
        var slidesperviewVideo = 2.2
        var initialslide = 0
        var spacebetween1 = 10
        var spacebetween2 = 20
      }
      //视频轮播
      this.swiper2 = new Swiper(".carousel-container-video", {
        slidesPerView: slidesperviewVideo,
        initialSlide: initialslide,
        spaceBetween: spacebetween2,
        centeredSlides: true,
        // loop: true,
        pagination: {
          el: ".swiper-pagination-video",
        },
      });
      //切换视频事件
      this.swiper2.on('slideChange', function () {
        video1.pause()
        video2.pause()
        video3 && video3.pause()
        video4 && video4.pause()
        video5 && video5.pause()
        video6 && video6.pause()
        video7 && video7.pause()
        for (let i = 0; i < that.videoUrls.length; i++) {
          that.videoUrls[i].showFullVideo = false;
        }
      });
      //图片弹出轮播
      // window.addEventListener("click", this.showCover)
      this.swiperCover = new Swiper('.swiper-container2', {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        pagination: {
          el: '.swiper-pagination2',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-button-next2',
          prevEl: '.swiper-button-prev2',
        },
      });
    })

    //   if(this.$refs.videoPlayerSwiper){
    window.addEventListener('scroll', function () {
      var vh = window.innerHeight;
      var vw = window.innerWidth;
      if (!that.isPortrait) {//pc
        if (document.getElementById("specialPosition")) {
          var pageTopPc = document.getElementById("specialPosition").getBoundingClientRect().top
          console.log(pageTopPc)
          if (pageTopPc <= - 3 / 16 * vw || pageTopPc >= 8 / 16 * vw) {
            video1.pause()
            video2.pause()
            video3 && video3.pause()
            video4 && video4.pause()
            video5 && video5.pause()
            video6 && video6.pause()
            video7 && video7.pause()
          }
        }
      } else {//mob
        if (document.getElementById("specialPosition")) {
          var pageTopMob = document.getElementById("specialPosition").getBoundingClientRect().top
          // console.log(pageTopPc)
          if (pageTopMob <= - 9 / 16 * vw || pageTopMob >= vh) {
            video1.pause()
            video2.pause()
            video3 && video3.pause()
            video4 && video4.pause()
            video5 && video5.pause()
            video6 && video6.pause()
            video7 && video7.pause()
          }
        }
      }
    })
    //   }

  },
  destroyed() {
    window.removeEventListener("resize", this.setResize);
    //clearInterval(this.dateCheckInterval);
  },
  methods: {
    // checkVideoCountByDate() {
    //   //根据当前日期判断有几个视频
    //   //2025-06.08之前
    //   if(new Date().getTime() < new Date("2025-06-08").getTime()){
    //     this.videoCount = 2
    //   }
    //   //2025-06.09之前
    //   else if(new Date().getTime() < new Date("2025-06-09").getTime()){
    //     this.videoCount = 3
    //   }
    //   //2025-06.10之前
    //   else if(new Date().getTime() < new Date("2025-06-10").getTime()){
    //     this.videoCount = 4
    //   }
    //   //2025-06.11之前
    //   else if(new Date().getTime() < new Date("2025-06-11").getTime()){
    //     this.videoCount = 5
    //   }
    //   //2025-06.12之前
    //   else if(new Date().getTime() < new Date("2025-06-12").getTime()){
    //     this.videoCount = 6
    //   }
    //   //2025-06.12及2025-06.12之后
    //   else if(new Date().getTime() >= new Date("2025-06-12").getTime()){
    //     this.videoCount = 7
    //   }
    // },
    getPartVideos() {
      var list = this.videoUrls.slice(0, this.videoCount)
      return list;
    },
    getRefName(index) {
      return `videoPlayerSwiper${index}`;
    },
    setResize() {
      this.isPortrait = isPortraitFun();
    },
    playFullVideo(index) {
      this.$emit("stopAudio");
      this.videoUrls[index].showFullVideo = true;
      setTimeout(() => {
        document.getElementById("videoPlayerSwiper" + index).play();
      }, 100);
    },
    restartPreviewVideo() {
      var that = this
      this.$emit("distinctive", false);
      for (let i = 0; i < that.videoUrls.length; i++) {
        that.videoUrls[i].showFullVideo = false;
      }
    },
    showCover(e) {

      const index = e.target.getAttribute('data-index')
      console.log(index);
      console.log(1111);
      if (index) {
        this.isShowCover = true
        this.$nextTick(() => {
          this.swiperCover = new Swiper('.swiper-container2', {
            initialSlide: index,
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            pagination: {
              el: '.swiper-pagination2',
              type: 'fraction'
            },
            navigation: {
              nextEl: '.swiper-button-next2',
              prevEl: '.swiper-button-prev2',
            },
          });
        })
        // window.removeEventListener("click", this.showCover)
        //开始全屏预览
        window.parent.postMessage({ type: 'ev5ImgSwiperOpen' }, '*')
      }
    },
    hideCover() {
      this.isShowCover = false
      this.swiperCover = null
      window.addEventListener("click", this.showCover);
      //关闭全屏预览
      window.parent.postMessage({ type: 'ev5ImgSwiperClose' }, '*')
    }
  },
}
</script>
<style lang="scss" scoped>
.video-container {
  cursor: pointer;
  // background-color: rgba(20, 92, 142, 1);
  position: relative;

  @media (min-width: 767px) {
    width: calc(967 / 2200 * 100vw);
    height: calc((636 + 0) / 2200 * 100vw);
    img {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 90;
      width: 100%;
      // height: calc(636 / 2200 * 100vw);
      height: 100%;
    }
  }

  @media (max-width: 767px) {
    width: calc(296 / 375 * 100vw);
    height: calc((220 + 0) / 375 * 100vw);
    display: flex;
    justify-content: center;
    align-items: center;
    // height: calc(216 / 375 * 100vw);
    img {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 90;
      // width: calc(296 / 375 * 100vw);
      // height: calc(636 / 2200 * 100vw);
      width: 100%;
      height: 100%;
    }
  }
  
  .icons {
    position: absolute;
    top: calc(50% - 25px);
    left: calc(50% - 25px);
    z-index: 99;

    a {
      .icon {
        display: block;
        width: 50px;
        height: 50px;
        //background: url('../../assets/images/play-circle-line.png') no-repeat;
        background-size: 100% 100%;
        color: #fff;
      }
    }
  }

  .full-video-pc {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
  }

  .full-video-mob {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(170 / 375 * 100vw);
    // height: 72%;
    // width: calc(296 / 375 * 100vw);
    z-index: 100;
    background-color: black;
  }
}

.title-text {
  color: #ffffff;
  width: 100%;
  text-align: center;

  @media (min-width: 767px) {
    font-size: calc(45 / 1920 * 100vw);
    padding: calc(100 / 1920 * 100vw) 0;
  }

  @media (max-width: 767px) {
    font-size: calc(22 / 375 * 100vw);
    padding-top: calc(60 / 375 * 100vw);
    padding-bottom: calc(20 / 375 * 100vw);
  }
}

//pc start
@media (min-width: 767px) {

  .threepage {
    position: relative;
    height: calc(1238 / 2200 * 100vw);
    width: 100%;
    user-select: none;
    // background-image: url('https://www.kia.cn/assets/~/media/images/activity/aowang2025/third-page-background-pc.png');
    // background-repeat: no-repeat; /* 防止重复 */
    // background-size: cover;
  }
  .bg {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .video-swiper-icon{
    position: absolute;
    top: calc(152 / 2200 * 100vw);
    left: calc(330 / 2200 * 100vw);
    width: calc(316 / 2200 * 100vw);
    height: calc(135 / 2200 * 100vw);
  }

  .carousel-hover-stripe {
    position: absolute;
    left: calc(110 / 1920 * 100vw);
    top: calc(50% - 339 / 1920 * 100vw);
    width: calc(1206 / 1920 * 100vw);
    height: calc(105 / 1920 * 100vw);
    // font-size: calc(34 / 1920 * 100vw);
    font-family: 'zhonghei';
    background-image: url('https://www.kia.cn/assets/~/media/images/activity/aowang2025/purple-stripe-pc.png');
    background-repeat: no-repeat;
    /* 防止重复 */
    // background-position: center; /* 图片居中 */
    background-size: 100% 100%;
    z-index: 99;
  }

  .carousel-container-video {
    width: 100%;
    // height: calc(543 / 1920 * 100vw);
    position: absolute;
    left: 0;
    top: calc(345 / 2200 * 100vw);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    ::v-deep .swiper-pagination-bullets {
      display: flex;
      align-items: center;
      justify-content: end;
      padding-right: calc(358 / 2200 * 100vw);
    }
    ::v-deep .swiper-pagination-bullet {
      margin: 0 calc(4 / 2200 * 100vw);
      width: calc(14 / 2200 * 100vw);
      height: calc(14 / 2200 * 100vw);
      border-radius: calc(14 / 2200 * 100vw);
      background-color: #D9D9D9;
    }

    ::v-deep .swiper-pagination-bullet-active {
      background-color: #ffffff;
      display: inline-block;
    }

    ::v-deep .swiper-slide {
      opacity: 0.5;

      .icons {
        display: none;
      }

      .video-text {
        display: none;
      }
    }

    ::v-deep .swiper-slide-active {
      opacity: 1;

      .icons {
        display: block;
      }

      .video-text {
        position: absolute;
        top: calc(543/1920 * 100vw);
        display: block;
        color: #ffffff;
        font-size: calc(25 / 1920 * 100vw);
        padding: calc(30 / 1920 * 100vw) 0;

      }
    }
  }

  .carousel-container-img {
    width: calc(1674 / 1920 * 100vw);
    // height: calc(492 / 1920 * 100vw);
    // position: absolute;
    // left: 0;
    // top: calc(50% - 339 / 1920 * 100vw );
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 0 calc(123 / 1920 * 100vw) 0 calc(123 / 1920 * 100vw);

    ::v-deep .swiper-pagination-progressbar {
      position: relative;
      width: 100%;
      height: calc(4 / 1920 * 100vw);
      border-radius: 0;
    }

    ::v-deep .swiper-pagination-progressbar-fill {
      background-color: #ffffff;
      display: inline-block;
    }
  }

  .text-container {
    width: calc(484 / 1920 * 100vw);
    height: calc(674 / 1920 * 100vw);
    position: absolute;
    right: calc(70 / 1920 * 100vw);
    top: calc(50% - 339 / 1920 * 100vw);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-family: 'zhonghei';
    letter-spacing: calc(2 / 1920 * 100vw);
    color: white;

    img {
      // margin-top: calc(60 / 1920 * 100vw);
      width: calc(470 / 1920 * 100vw);
      height: calc(485 / 1920 * 100vw);
    }

    .first-title-box {
      padding: calc(4 / 1920 * 100vw) 0 calc(4 / 1920 * 100vw) calc(4 / 1920 * 100vw);
      border: solid 2px white;
      width: 90%;
      font-size: calc(40 / 1920 * 100vw);
      font-family: 'zhonghei';
      margin-bottom: calc(34 / 1920 * 100vw)
    }

    .first-title-en {
      font-size: calc(34 / 1920 * 100vw);
    }

    .divise-fat {
      border: solid 1px white;
      width: 90%;
    }

    .second-title-box {
      padding: calc(34 / 1920 * 100vw) 0;
      font-size: calc(24 / 1920 * 100vw);
    }

    .divise-thin {
      border-top: dashed 1px white;
      width: 95%;
    }

    .third-text {
      width: 95%;
      height: calc(250 / 1920 * 100vw);
      font-size: calc(14 / 1920 * 100vw);
      line-height: calc(36 / 1920 * 100vw);
    }

  }

  .btn-box {
    position: absolute;
    border: solid 1px white;
    border-radius: 4px;
    color: white;
    padding: calc(5 / 1920 * 100vw) calc(8 / 1920 * 100vw) calc(2 / 1920 * 100vw) calc(8 / 1920 * 100vw);
    font-size: calc(18 / 1920 * 100vw);
    left: calc(1345 / 1920 * 100vw);
    top: calc(50% + 339 / 1920 * 100vw - 40 / 1920 * 100vw - 80 / 1920 * 100vw);
    cursor: pointer;
    font-family: 'heijian';
  }

  .news-pagination {
    position: absolute;
    width: calc(470 / 1920 * 100vw);
    left: calc(1345 / 1920 * 100vw);
    top: calc(50% + 339 / 1920 * 100vw - 35 / 1920 * 100vw);
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
      font-size: calc(20 / 1920 * 100vw);
      color: #fff;
      margin-right: calc(14 / 1920 * 100vw);
      padding: 0 calc(4 / 1920 * 100vw);
      cursor: pointer;
    }

    .news-pagination-active {}

    .btn-last {
      font-size: calc(20 / 1920 * 100vw);

      &:before {
        content: "\e66d";
        font-family: icon;
        font-size: calc(20 / 1920 * 100vw);
        width: calc(16 / 1920 * 100vw);
        display: inline-block;
        text-align: center;
        transition: 0.3s;
        vertical-align: 0px;
      }
    }

    .btn-next {
      font-size: calc(20 / 1920 * 100vw);

      &:after {
        content: "\e628";
        font-family: icon;
        font-size: calc(20 / 1920 * 100vw);
        width: calc(16 / 1920 * 100vw);
        display: inline-block;
        text-align: center;
        transition: 0.3s;
        vertical-align: -1px;
      }
    }
  }
}

//pc end
//mob strat
@media (max-width: 767px) {
  ::v-deep .swiper-slide {
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      opacity: 0.5;
  }
  ::v-deep .swiper-slide-active {
    opacity: 1;
  }
  ::v-deep .swiper-pagination-bullets {
    // display: flex;
    // align-items: center;
    // justify-content: end;
    // padding-right: calc(358 / 2200 * 100vw);
  }
  ::v-deep .swiper-pagination-bullet {
    margin: 0 calc(4 / 375 * 100vw);
    width: calc(8 / 375 * 100vw);
    height: calc(8 / 375 * 100vw);
    border-radius: calc(8 / 375 * 100vw);
    background-color: #D9D9D9;
  }

  ::v-deep .swiper-pagination-bullet-active {
    background-color: #ffffff;
    display: inline-block;
  }
  .threepage {
    margin-top: -1px;
    position: relative;
    height: calc(555 / 375 * 100vw);
    width: 100%;
    user-select: none;
    background-color: rgba(30, 128, 193, 1);
    // background-image: url('https://www.kia.cn/assets/~/media/images/activity/aowang2025/third-page-background-mob.png');
    // background-repeat: no-repeat; /* 防止重复 */
    // background-size: cover;
    // padding-top: calc(50 / 375 * 100vw );
    // padding-bottom: calc(80 / 375 * 100vw );
  }
  .bg {
    position: absolute;
    width: 100%;
  }
  .carousel-hover-stripe {
    position: absolute;
    left: calc(26.5 / 375 * 100vw);
    bottom: calc((50 - 40 + 357) / 375 * 100vw);
    width: calc(322.1 / 375 * 100vw);
    height: calc(40 / 375 * 100vw);
    border-radius: 15px 15px 0 0;
    // font-size: calc(34 / 1920 * 100vw);
    font-family: 'zhonghei';
    background-image: url('https://www.kia.cn/assets/~/media/images/activity/aowang2025/purple-stripe-mob.png');
    background-repeat: no-repeat;
    /* 防止重复 */
    // background-position: center; /* 图片居中 */
    background-size: 100% 100%;
    z-index: 99;
  }

  .carousel-container-video {
    width: calc(375 / 375 * 100vw);
    // margin-left: calc(26.5 / 375 * 100vw);
    // height: calc(220 / 375 * 100vw);
    position: absolute;
    left: 0;
    top: calc(200 / 375 * 100vw );
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .video-text {
      position: absolute;
      top: calc(216/375 * 100vw);
      display: block;
      color: #ffffff;
      font-size: calc(16 / 375 * 100vw);
      padding-top: calc(13 / 375 * 100vw);

    }
  }

  .carousel-container-img {
    width: 100%;
    height: calc(251 / 375 * 100vw);
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    ::v-deep .swiper-pagination-progressbar {
      position: relative;
      width: 100%;
      height: calc(4 / 1920 * 100vw);
      border-radius: 0;
    }

    ::v-deep .swiper-pagination-progressbar-fill {
      background-color: #ffffff;
      display: inline-block;
    }

    .img-next {
      position: absolute;
      width: 50px;
      height: 50px;
      right: calc(10 / 375 * 100vw);
      top: calc(50% - 25px);
      z-index: 11;
    }

    .img-prev {
      position: absolute;
      width: 50px;
      height: 50px;
      left: calc(10 / 375 * 100vw);
      top: calc(50% - 25px);
      z-index: 11;
      transform: scaleX(-1);
    }
  }

  .text-container {
    width: calc(322 / 375 * 100vw);
    height: calc(233.67 / 375 * 100vw);
    // position: absolute;
    margin-left: calc(26.5 / 375 * 100vw);
    padding-bottom: calc(75 / 375 * 100vw);
    // padding-top: calc(50 / 375 * 100vw );
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-family: 'zhonghei';
    letter-spacing: calc(2 / 375 * 100vw);
    color: white;

    img {
      width: calc(322 / 375 * 100vw);
      height: calc(158.67 / 375 * 100vw);
    }

    .first-title-box {
      padding: calc(1 / 375 * 100vw) calc(6 / 375 * 100vw);
      border: solid 2px white;
      width: 75%;
      font-size: calc(20 / 375 * 100vw);
      font-family: 'Kia Signature';
      margin-bottom: calc(20 / 375 * 100vw);
      font-family: 'zhonghei';

    }

    .first-title-en {
      font-size: calc(16 / 375 * 100vw);
    }

    .divise-fat {
      display: none;
    }

    .second-title-box {
      padding: calc(20 / 375 * 100vw) 0;
      font-size: calc(14 / 375 * 100vw);
      font-family: 'zhonghei';

    }

    .divise-thin {
      border-top: dashed 1px white;
      width: 100%;
    }

    .third-text {
      // height: calc(80 / 375 * 100vw);
      font-size: calc(10 / 375 * 100vw);
      line-height: calc(35 / 375 * 100vw);
      font-family: 'zhonghei';
      padding-bottom: calc(10 / 375 * 100vw);

    }

  }

  .btn-box {
    position: absolute;
    border: solid 1px white;
    border-radius: 2px;
    color: white;
    padding: calc(5 / 375 * 100vw) calc(8 / 375 * 100vw);
    font-size: calc(11 / 375 * 100vw);
    right: calc(27 / 375 * 100vw);
    top: calc(225 / 375 * 100vw);
  }

  .news-pagination {
    position: absolute;
    width: calc(285 / 375 * 100vw);
    top: calc(530 / 375 * 100vw);
    margin-left: calc(45 / 375 * 100vw);
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
      color: #fff;
      // padding: 0 calc(8 / 375 * 100vw);
    }

    .news-pagination-active {}

    .btn-last {
      font-size: calc(12 / 375 * 100vw);

      &:before {
        content: "\e66d";
        font-family: icon;
        font-size: calc(12 / 375 * 100vw);
        width: calc(16 / 375 * 100vw);
        display: inline-block;
        text-align: center;
        transition: 0.3s;
        vertical-align: -1px;
      }
    }

    .btn-next {
      font-size: calc(12 / 375 * 100vw);

      &:after {
        content: "\e628";
        font-family: icon;
        font-size: calc(12 / 375 * 100vw);
        width: calc(16 / 375 * 100vw);
        display: inline-block;
        text-align: center;
        transition: 0.3s;
        vertical-align: -1px;
      }
    }
  }
}

@media screen and (orientation: portrait) {

  //隐藏掉鼠标悬浮出现的左右切换按钮
  ::v-deep .el-carousel__arrow {
    display: none;
  }

  // .swiper-pagination-img{
  //   top: calc(475 / 375 * 100vw) !important;
  //   bottom: calc(485 / 375 * 100vw) !important;
  // }

}

::v-deep .el-carousel__indicators {
  // display: none;
  bottom: 0;
}

::v-deep .el-carousel__button {
  width: 10px;
  height: 10px;
  border-radius: 10px;
}

::v-deep .is-active .el-carousel__button {
  // background-color: #ffffff;
  background: rgba(0, 80, 255, 1);
  width: 10px;
  height: 10px;
  border-radius: 10px;
}

//隐藏掉鼠标悬浮出现的左右切换按钮
// ::v-deep .el-carousel__arrow{
//   display: none;
// }
::v-deep .el-carousel__arrow {
  background-color: #ffffff;

  i {
    font-size: 30px;
  }
}

.el-carousel__arrow:hover {
  background-color: #475669;
}

::v-deep .el-carousel__container {
  position: relative;
  height: 100%;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #ffffff;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #ffffff;
}

.swiper {
  width: 100%;
  height: 400px;
}

// .swiper-slide {
//   text-align: center;
//   font-size: 18px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
// }

// .swiper-slide img {
//   display: block;
//   width: 100%;
//   height: 100%;
//   object-fit: cover;
// }
.swiper-pagination-video {
  width: 100%;
  text-align: center;
  z-index: 10;
  position: static;

  @media (min-width: 767px) {
    padding: calc(100 / 1920 * 100vw) 0 calc(50 / 1920 * 100vw) 0;
  }

  @media (max-width: 767px) {
    padding: calc(36 / 375 * 100vw) 0 0 0;
  }
}

.swiper-pagination-img {
  // position: absolute;
  // bottom: 70px;
  // left: 0;
  width: 100%;
  text-align: center;
  z-index: 10;

  @media (min-width: 767px) {
    // padding: calc(100 / 1920 * 100vw) 0 calc(50 / 1920 * 100vw) 0;
    margin: calc(100 / 1920 * 100vw) 0;
  }

  @media (max-width: 767px) {}
}

.cover {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background: #000000;
  z-index: 210;

  .el-icon-close {
    color: #fff;
    font-size: 40px;
    cursor: pointer;
    position: absolute;
    z-index: 99;
    right: 50px;
    top: 50px;

    &-mob {
      font-size: 30px;
      right: 20px;
    }
  }

  .pop {
    position: relative;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .swiper-container2 {
    width: 70vw;
    height: auto;
    overflow: hidden;

    /* position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      overflow: hidden; */
    /* height: 80%; */
    .swiper-slide {
      background: rgba($color: #000000, $alpha: 0);

      // img {
      //   width: 78%;
      //   height: auto;
      // }

      @media (max-width: 768px) {
        img {
          width: 100%;
        }
      }
    }

    &-mob {
      width: 100vw;
    }
  }

  .swiper-pagination-fraction {
    position: absolute;
    z-index: 999;
    bottom: -30px;
    color: #fff;
  }

  .swiper-button-next,
  .swiper-button-prev {
    background: rgba($color: #000, $alpha: 0);
    transition: all .5s;
    color: #fff;
    font-size: 30px;
    font-weight: bold;
    transform: translateY(-50%);

    &::after {
      /* content: none; */
      font-size: 30px;
      font-weight: 400;
      color: #fff;
    }

    &:hover {
      background: rgba($color: #05141F, $alpha: 0);
    }

    &:hover::after {
      color: #fff;
    }
  }

  .swiper-button-prev,
  .swiper-button-next:focus {
    outline: none;
  }

  .swiper-button-next2 {
    right: 20px;
    transform: translateY(-25%);
  }

  .swiper-button-prev2 {
    left: 20px;
    transform: translateY(-25%);
  }

  @media (max-width: 768px) {
    .swiper-button-next2 {
      width: auto;
      height: auto;
      right: 2%;
      transform: translateY(25%);
    }

    .swiper-button-prev2 {
      width: auto;
      height: auto;
      left: 2%;
      transform: translateY(25%);
    }
  }
}
</style>